<template>
    <div :class="{'gid' : grid}">
        <div class="spinner m-b" :class="position">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
        </div>
    </div>
</template>
<style>
    .spinner-left {
        width: 100px;
    }
    .spinner  {
        margin-top: 20px !important;
    }
    .lower > .spinner {
        margin-top: 100px !important;
    }
    .little-lower > .spinner {
        margin-top: 30px !important;
    }
    .no-margin-top > .spinner {
        margin-top: 0px !important;
    }
    .center {
        margin: 0 auto;
    }
    .spinner {
        width: 70px;
    }

    .spinner > div {
        width: 18px;
        height: 18px;
        background-color: RGBA(0,0,0,0.2);

        border-radius: 100%;
        display: inline-block;
        -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
        animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    }

    .spinner .bounce1 {
        -webkit-animation-delay: -0.32s;
        animation-delay: -0.32s;
    }

    .spinner .bounce2 {
        -webkit-animation-delay: -0.16s;
        animation-delay: -0.16s;
    }

    @-webkit-keyframes sk-bouncedelay {
        0%, 80%, 100% { -webkit-transform: scale(0) }
        40% { -webkit-transform: scale(1.0) }
    }

    @keyframes sk-bouncedelay {
        0%, 80%, 100% {
            -webkit-transform: scale(0);
            transform: scale(0);
        } 40% {
              -webkit-transform: scale(1.0);
              transform: scale(1.0);
          }
    }

</style>
<script>
export default {
  props: ['position', 'css', 'grid'],
  name: 'spinner'
}
</script>
